import React, { CSSProperties } from 'react'
import { css } from '@emotion/core'

type Props = {
  onClick: (e?: React.MouseEvent<HTMLElement>) => void
  style?: CSSProperties
  disabled?: boolean
}
export const DeleteIcon: React.FC<Props> = ({ onClick, style, disabled = false }) => {
  return (
    <div css={buttonStyle} style={style}>
      <img
        src={require('@/static/images/icon_delete2.svg')}
        className="icon"
        onClick={e => {
          if (disabled) return
          e.stopPropagation()
          onClick(e)
        }}
        style={{
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        }}
      />
    </div>
  )
}

const buttonStyle = css({
  display: 'flex',
  width: 30,
  height: 30,
  '.icon': {
    width: 30,
    height: 30,
    cursor: 'pointer',
    opacity: 1,
  },
})
